import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "About Us": "About Us",
       "About EMKA DEV": "About EMKA ",
       "Software that never clocks out.": "Code from Iraq. Impact everywhere",
      "Round-the-clock delivery from a team that ships while your timezone sleeps.": "We turn ideas into technology, and technology into impact",
    
      "Company Introduction": "Team Introduction",
      "Company Intro Text": "We are a team specialized in creating professional programs, websites, and mobile applications. We also develop documents, graduation research, and projects. Our goal is to help people bring their ideas to life in the real world, transforming them into apps or websites in a simple, reliable, and trustworthy way.",
      "The EMKA DEV Story": " EMKA  Story",
      "Founded in 2024": "Founded in 2022",
      "Founded Text": "EMKA  began in 2022, starting with small apps designed to assist elderly people in accessing their medicines easily. For two years, we also operated as a technical support store, helping gamers and computer users solve software and hardware issues remotely from anywhere. Our dedication to helping customers achieve their goals earned their trust and loyalty, paving the way for our growth in app and web development.",
      "Our Mission": "Our Mission",
      "Mission Text": "To simplify the process of developing apps and websites, delivering innovative, reliable, and efficient solutions to individuals and businesses while building trust and supporting creativity.",
      "Our Vision": "Our Vision",
      "Vision Text": "TTo become a leading platform for accessible, high-quality app and web development, enabling people to bring their ideas to life faster and with complete confidence.",
      "Core Values": "Core Values",
      "Innovation": "Innovation",
      "Reliability": "Reliability",
      "User-Centric Design": "User-Centric Design",
      "Transparency & Trust": "Transparency & Trust",
      "Agility": "Agility",
      "Start Your Project Today →": "Start Your Project Today →",
      "Our mission and team": "Our mission and team",
      "Projects": "Projects",
      "See our latest work": "See our latest work",
      "Contact": "Start a Project",
      "Start your project now": "Have an idea? Let's build it.",
      "A selection of what we build.": "A selection of what we build.",
      "SYSTEMS BUILT WITH PURPOSE": "SYSTEMS BUILT WITH PURPOSE",
      "View Project": "View Project",
      "PROJECTS": "PROJECTS",
      "About this project": "About this project",
      "Available on": "Available on",

      // OrderTrackingPage
      "Please enter your order number.": "Please enter your order number.",
      "Unable to find your order.": "Unable to find your order.",
      "Something went wrong. Please try again.": "Something went wrong. Please try again.",
      "Please enter your answer.": "Please enter your answer.",
      "Unable to submit your answer.": "Unable to submit your answer.",
      "Your answer has been submitted successfully.": "Your answer has been submitted successfully.",
      "EMKA // ORDER TRACKING": "EMKA // ORDER TRACKING",
      "// PROJECT STATUS": "// PROJECT STATUS",
      "Track Your Order": "Track Your Order",
      "Enter your order number to view the latest status of your project.": "Enter your order number to view the latest status of your project.",
      "Order Number": "Order Number",
      "Checking...": "Checking...",
      "Track Order": "Track Order",
      "// ORDER FOUND": "// ORDER FOUND",
      "Welcome": "Welcome",
      "Project Type": "Project Type",
      "Your order is under review": "Your order is under review",
      "Our team is reviewing your project request. We will update your order once the review is complete.": "Our team is reviewing your project request. We will update your order once the review is complete.",
      "Your project is in progress": "Your project is awaiting your response",
      "Price": "Price",
      "Answer": "Answer",
      "Note": "Note",
      "Your Answer": "Your Answer",
      "Enter your answer here...": "Enter your answer here...",
      "Submit Answer": "Submit Answer",
      "Submitting...": "Submitting...",
      "// RESPONSE SUBMITTED": "// RESPONSE SUBMITTED",
      "Your answer has been submitted": "Your answer has been submitted",
      "Your response has been received. You cannot submit another answer for this order.": "Your response has been received. You cannot submit another answer for this order.",
      "Order Status": "Order Status",
      "Your order status has been updated. Please check again later for more information.": "Your order status has been updated. Please check again later for more information.",
      "EMKA // Your project, tracked with clarity.": "EMKA // Your project, tracked with clarity.",
      "EMKA_CORE // ORDER SYSTEM ACTIVE": "EMKA_CORE // ORDER SYSTEM ACTIVE",

      // AskQuestionPage
      "Ask a Question": "Ask a Question",
      "Name": "Name",
      "Email": "Email",
      "Phone (Optional)": "Phone (Optional)",
      "Title": "Title",
      "Your Question": "Your Question",
      "Submit": "Submit",
      "Submitting...": "Submitting...",
      "Please fill all required fields.": "Please fill all required fields.",
      "Your question has been sent successfully!": "Your question has been sent successfully!"
,

  // ContactPage
      "Contact Us": "Contact Us",
      "Ask a Question": "Ask a Question",
      "Build a Project": "Build a Project",
       "Let's Build Something": "Let's Build Something",
  "Have a question or an idea? Choose how you'd like to start.": "Have a question or an idea? Choose how you'd like to start.",
      "// GENERAL INQUIRY": "// GENERAL INQUIRY",
  "Ask a Question": "Ask a Question",
  "Have a question about our services, technology, or how we can help?": "Have a question about our services, technology, or how we can help?",
  "Already submitted a project? Track your order and check its current status.": "Already submitted a project? Track your order and check its current status.",
      "// ORDER TRACKING": "// ORDER TRACKING",
      "// PROJECT INITIATION": "// PROJECT INITIATION",
  "Build a Project": "Build a Project",
  "Have an idea for an app or website? Let's turn it into something real.": "Have an idea for an app or website? Let's turn it into something real.",
      "// EMKA — LET'S BUILD SOMETHING": "// EMKA — LET'S BUILD SOMETHING",
      "Whether you have a question or a project in mind, choose where you want to start.": "Whether you have a question or a project in mind, choose where you want to start.",
      "Continue": "Continue",
      "Toggle language menu": "Toggle language menu",
      "English": "English",
      "Arabic": "Arabic",
      "From an idea to a working product — EMKA is ready.": "From an idea to a working product — EMKA is ready.",
      "EMKA_CORE // READY TO RECEIVE YOUR IDEA": "EMKA_CORE // READY TO RECEIVE YOUR IDEA",

  // BuildProjectPage
      "What do you want to build?": "What do you want to build?",
      "Mobile App": "Mobile App",
      "Website": "Website",
      "You're ready to build": "You're ready to build",
      "Please complete the project form to tell us what you need.": "Please complete the project form to tell us what you need.",
      "Previous": "Previous",
      "Click here to start": "Click here to start",
      "Please enter your name.": "Please enter your name.",
      "Please enter your email.": "Please enter your email.",
      "Please enter a valid email address.": "Please enter a valid email address.",
      "Please enter your phone number.": "Please enter your phone number.",
      "Please select a project type.": "Please select a project type.",
      "Tally form link was not returned.": "Tally form link was not returned.",
      "Let's turn your idea into reality": "Let's turn your idea into reality",
      "Complete your information so we can start working on your idea.": "Complete your information so we can start working on your idea.",
      "Enter your name": "Enter your name",
      "Enter your email": "Enter your email",
      "Phone Number": "Phone Number",
      "Enter your phone number": "Enter your phone number",
      "Creating your order...": "Creating your order...",
      "Start Building": "Start Building",
 
      // ProjectsPage
      "No images": "No images",
      "images": "images",
      "View Details": "View Details",
      "Our Projects": "Our Projects",
      "Loading projects...": "Loading projects...",
      "Failed to load projects.": "Failed to load projects.",
      "No projects available.": "No projects available.",
      "Close": "Close",
      "Change language": "Change language",
      "Previous image": "Previous image",
      "Next image": "Next image",
      "No images available.": "No images available.",
      "Android": "Android",
      "Both": "Both",
      "Download the app": "Download the app",
      "App Store": "App Store",
      "Google Play": "Google Play",

      // BuildWebPage
      "Yes": "Yes",
      "No": "No",
      "Step 1: Website Basics": "Step 1: Website Basics",
      "Website Type": "Website Type",
      "Select website type": "Select website type",
      "Business": "Business",
      "Portfolio": "Portfolio",
      "E-commerce": "E-commerce",
      "Blog": "Blog",
      "Other": "Other",
      "Do you need a login system?": "Do you need a login system?",
      "Responsive design?": "Responsive design?",
      "Step 2: Features & Functionality": "Step 2: Features & Functionality",
      "E-commerce functionality?": "E-commerce functionality?",
      "Blog or news section?": "Blog or news section?",
      "Preferred design style": "Preferred design style",
      "Select design style": "Select design style",
      "Minimalist": "Minimalist",
      "Modern": "Modern",
      "Classic": "Classic",
      "Creative": "Creative",
      "Main features": "Main features",
      "Describe features": "Describe features",
      "Other special features": "Other special features",
      "Other features": "Other features",
      "Step 3: Content & Branding": "Step 3: Content & Branding",
      "Brand style, colors, logos": "Brand style, colors, logos",
      "Brand style": "Brand style",
      "Pages needed": "Pages needed",
      "Home, About, Services...": "Home, About, Services...",
      "SEO optimization?": "SEO optimization?",
      "Multilingual support?": "Multilingual support?",
      "Step 4: Additional Requirements": "Step 4: Additional Requirements",
      "Example websites": "Example websites",
      "Target audience": "Target audience",
      "Technical requirements": "Technical requirements",
      "Step 5: Contact Info": "Step 5: Contact Info",
      "Country": "Country",
      "Phone": "Phone",
      "Next": "Next",
      "Your website request has been submitted successfully!": "Your website request has been submitted successfully!",
      "Failed to submit request.": "Failed to submit request.",
      "Error submitting request. Please try again.": "Error submitting request. Please try again.",

      // ContactPage
      "EMKA // CONNECTION POINT": "EMKA // CONNECTION POINT",
    }
  },
  ar: {
    translation: {
      // HomePage
      "About Us": "من نحن",
       "About EMKA DEV": "حول EMKA ",
      "Company Introduction": "مقدمة عن الفريق",
      "Company Intro Text": "  نحن فريق متخصص في إنشاء البرامج الاحترافية والمواقع الإلكترونية وتطبيقات الهواتف المحمولة. كما نقوم بتطوير المستندات وأبحاث المشاريع والتخرج. هدفنا هو مساعدة الناس على تحويل أفكارهم إلى واقع من خلال التطبيقات أو المواقع بطريقة سهلة وموثوقة وجديرة بالثقة.",
      "The EMKA DEV Story": "قصة EMKA ",
      "Founded in 2024": "تأسست في 2022",
      "Founded Text": "بدأت EMKA  في عام 2022، حيث بدأت بتطوير تطبيقات صغيرة تهدف لمساعدة كبار السن على الوصول إلى أدويتهم بسهولة. كما عملنا لمدة عامين كمتجر دعم فني، مساعدة اللاعبين وأي مستخدم للكمبيوتر على حل مشاكل البرمجيات والأجهزة عن بُعد من أي مكان. لقد كسبنا ثقة عملائنا وولاءهم، مما ساعدنا على النمو في مجال تطوير التطبيقات والمواقع.",
      "Our Mission": "مهمتنا",
      "Mission Text": "تبسيط عملية تطوير التطبيقات والمواقع، وتقديم حلول مبتكرة وموثوقة وفعالة للأفراد والشركات مع بناء الثقة ودعم الإبداع.",
      "Our Vision": "رؤيتنا",
      "Vision Text": "أن نصبح منصة رائدة لتطوير التطبيقات والمواقع عالية الجودة بطريقة سهلة الوصول، مما يمكّن الناس من تحويل أفكارهم إلى واقع بسرعة وثقة كاملة.",
      "Core Values": "القيم الأساسية",
      "Innovation": "الابتكار",
      "Reliability": "الموثوقية",
      "User-Centric Design": "تصميم يركز على المستخدم",
      "Transparency & Trust": "الشفافية والثقة",
      "Agility": "المرونة",
      "Start Your Project Today →": "ابدأ مشروعك اليوم →",
      "Our mission and team": "مهمتنا وفريقنا",
      "Projects": "المشاريع",
      "See our latest work": "شاهد أعمالنا الأخيرة",
      "Contact": "ابدأ مشروعك",
      "Software that never clocks out.": "كود من العراق . أثر في كل مكان",
      "Round-the-clock delivery from a team that ships while your timezone sleeps.": "نحوّل الأفكار إلى تقنية، والتقنية إلى أثر",
      
      "Start your project now": "لديك فكرة؟ لنحوّلها إلى واقع.",
      "A selection of what we build.": "مجموعة مختارة من أعمالنا.",
      "SYSTEMS BUILT WITH PURPOSE": "أنظمة مبنية بهدف",
      "View Project": "عرض المشروع",
      "PROJECTS": "مشاريع",
      "About this project": "حول هذا المشروع",
      "Available on": "متوفر على",
      "Both": "كلاهما",
      "I do": "انا سأفعل",
      "Android": "أندرويد",
      "You do": "الشركة ",
      "I don't know": "لا أعلم",

      // OrderTrackingPage
      "Please enter your order number.": "يرجى إدخال رقم الطلب.",
      "Unable to find your order.": "تعذر العثور على طلبك.",
      "Something went wrong. Please try again.": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      "Please enter your answer.": "يرجى إدخال إجابتك.",
      "Unable to submit your answer.": "تعذر إرسال إجابتك.",
      "Your answer has been submitted successfully.": "تم إرسال إجابتك بنجاح.",
      "EMKA // ORDER TRACKING": "EMKA // تتبع الطلب",
      "// PROJECT STATUS": "// حالة المشروع",
      "Track Your Order": "تتبع طلبك",
      "Enter your order number to view the latest status of your project.": "أدخل رقم الطلب لمعرفة أحدث حالة لمشروعك.",
      "Order Number": "رقم الطلب",
      "Checking...": "جارٍ التحقق...",
      "Track Order": "تتبع الطلب",
      "// ORDER FOUND": "// تم العثور على الطلب",
      "Welcome": "مرحباً",
      "Project Type": "نوع المشروع",
      "Your order is under review": "يتم مراجعة طلبك الآن",
      "Our team is reviewing your project request. We will update your order once the review is complete.": "يقوم فريقنا بمراجعة طلب مشروعك. سنقوم بتحديث الطلب بمجرد اكتمال المراجعة.",
      "Your project is in progress": "مشروعك بانتظار ردك",
      "Price": "السعر",
      "Answer": "المتطلبات والملاحظات",
      "Note": "ملاحظة اضافية",
      "Your Answer": "إجابتك",
      "Enter your answer here...": "اكتب إجابتك هنا...",
      "Submit Answer": "إرسال الإجابة",
      "Submitting...": "جارٍ الإرسال...",
      "// RESPONSE SUBMITTED": "// تم إرسال الرد",
      "Your answer has been submitted": "تم إرسال إجابتك",
      "Your response has been received. You cannot submit another answer for this order.": "تم استلام ردك. لا يمكنك إرسال إجابة أخرى لهذا الطلب.",
      "Order Status": "حالة الطلب",
      "Your order status has been updated. Please check again later for more information.": "تم تحديث حالة الطلب. يرجى التحقق مرة أخرى لاحقاً لمزيد من المعلومات.",
      "EMKA // Your project, tracked with clarity.": "EMKA // مشروعك يتبع بوضوح.",
      "EMKA_CORE // ORDER SYSTEM ACTIVE": "EMKA_CORE // نظام الطلبات نشط",

      // BuildProjectPage
      "What do you want to build?": "ماذا تريد أن تبني؟",
      "Mobile App": "تطبيق هاتف",
      "Website": "موقع إلكتروني",
      "You're ready to build": "لنبدأ بتحويل فكرتك إلى واقع",
      "Please complete the project form to tell us what you need.": "أكمل نموذج المشروع وأخبرنا بما تحتاجه لتنفيذ فكرتك.",
      "Previous": "السابق",
      "Click here to start": "اضغط هنا للبدء",
      "Please enter your name.": "يرجى إدخال اسمك.",
      "Please enter your email.": "يرجى إدخال بريدك الإلكتروني.",
      "Please enter a valid email address.": "يرجى إدخال بريد إلكتروني صحيح.",
      "Please enter your phone number.": "يرجى إدخال رقم الهاتف.",
      "Please select a project type.": "يرجى اختيار نوع المشروع.",
      "Tally form link was not returned.": "لم يتم إرجاع رابط النموذج.",
      "Let's turn your idea into reality": "لنحوّل فكرتك إلى واقع",
      "Complete your information so we can start working on your idea.": "أكمل معلوماتك حتى نبدأ في العمل على فكرتك.",
      "Enter your name": "أدخل اسمك",
      "Enter your email": "أدخل بريدك الإلكتروني",
      "Phone Number": "رقم الهاتف",
      "Enter your phone number": "أدخل رقم هاتفك",
      "Creating your order...": "جارٍ إنشاء طلبك...",
      "Start Building": "ارسال ",

      // BuildWebPage
      "Yes": "نعم",
      "No": "لا",
      "Step 1: Website Basics": "الخطوة 1: أساسيات الموقع",
      "Website Type": "نوع الموقع",
      "Select website type": "اختر نوع الموقع",
      "Business": "تجاري",
      "Portfolio": "معرض أعمال",
      "E-commerce": "تجارة إلكترونية",
      "Blog": "مدونة",
      "Other": "أخرى",
      "Do you need a login system?": "هل تحتاج إلى نظام تسجيل دخول؟",
      "Responsive design?": "هل تحتاج إلى تصميم متجاوب؟",
      "Step 2: Features & Functionality": "الخطوة 2: الميزات والوظائف",
      "E-commerce functionality?": "هل تحتاج إلى وظائف التجارة الإلكترونية؟",
      "Blog or news section?": "هل تحتاج إلى قسم للمدونة أو الأخبار؟",
      "Preferred design style": "نمط التصميم المفضل",
      "Select design style": "اختر نمط التصميم",
      "Minimalist": "بسيط",
      "Modern": "حديث",
      "Classic": "كلاسيكي",
      "Creative": "إبداعي",
      "Main features": "الميزات الرئيسية",
      "Describe features": "صف الميزات المطلوبة",
      "Other special features": "ميزات خاصة أخرى",
      "Other features": "اذكر الميزات الأخرى",
      "Step 3: Content & Branding": "الخطوة 3: المحتوى والهوية",
      "Brand style, colors, logos": "نمط العلامة التجارية والألوان والشعارات",
      "Brand style": "صف نمط العلامة التجارية",
      "Pages needed": "الصفحات المطلوبة",
      "Home, About, Services...": "الرئيسية، من نحن، الخدمات...",
      "SEO optimization?": "هل تحتاج إلى تحسين محركات البحث؟",
      "Multilingual support?": "هل تحتاج إلى دعم عدة لغات؟",
      "Step 4: Additional Requirements": "الخطوة 4: متطلبات إضافية",
      "Example websites": "مواقع إلكترونية مثال",
      "Target audience": "الفئة المستهدفة",
      "Technical requirements": "المتطلبات التقنية",
      "Step 5: Contact Info": "الخطوة 5: معلومات التواصل",
      "Country": "البلد",
      "Phone": "رقم الهاتف",
      "Next": "التالي",
      "Your website request has been submitted successfully!": "تم إرسال طلب الموقع بنجاح!",
      "Failed to submit request.": "فشل إرسال الطلب.",
      "Error submitting request. Please try again.": "حدث خطأ أثناء إرسال الطلب. يرجى المحاولة مرة أخرى.",

      // ContactPage
      "EMKA // CONNECTION POINT": "EMKA // نقطة اتصال",
      "Frontend Details": "تفاصيل الواجهة الأمامية",
        "Roles, Hosting & Maintenance": "الأدوار والاستضافة والصيانة",

      
          // ContactPage
      "Contact Us": "تواصل معنا",
      "Ask a Question": "اطرح سؤالاً",
      "Build a Project": "بناء مشروع",
       "Let's Build Something": "لنَبْنِ شيئًا معًا",
  "Have a question or an idea? Choose how you'd like to start.": "لديك سؤال أو فكرة؟ اختر الطريقة التي تود أن تبدأ بها.",
      "// GENERAL INQUIRY": "// استفسار عام",
  "Ask a Question": "اسأل سؤالاً",
  "Have a question about our services, technology, or how we can help?": "لديك سؤال حول خدماتنا أو تقنياتنا أو كيف يمكننا مساعدتك؟",
  "Already submitted a project? Track your order and check its current status.": "هل لديك مشروع تم إرساله بالفعل؟ تتبع طلبك ومعرفة حالته الحالية.",
      "// ORDER TRACKING": "// تتبع الطلب",
      "// PROJECT INITIATION": "// بدء المشروع",
  "Build a Project": "ابنِ مشروعًا",
      "Have an idea for an app or website? Let's turn it into something real.": "لديك فكرة لتطبيق أو موقع؟ لنحوّلها إلى شيء حقيقي.",
      "// EMKA — LET'S BUILD SOMETHING": "// EMKA — لنَبْنِ شيئًا معًا",
      "Whether you have a question or a project in mind, choose where you want to start.": "سواء كان لديك سؤال أو مشروع في ذهنك، اختر من أين تريد أن تبدأ.",
      "Continue": "متابعة",
      "Toggle language menu": "فتح قائمة اللغة",
      "English": "الإنجليزية",
      "Arabic": "العربية",
      "From an idea to a working product — EMKA is ready.": "من فكرة إلى منتج يعمل — فريق EMKA جاهز.",
      "EMKA_CORE // READY TO RECEIVE YOUR IDEA": "EMKA_CORE // جاهز لاستقبال فكرتك",

      // AskQuestionPage
      "Ask a Question": "اطرح سؤالاً",
      "Name": "الاسم",
      "Email": "البريد الإلكتروني",
      "Phone (Optional)": "رقم الهاتف (اختياري)",
      "Title": "العنوان",
      "Your Question": "سؤالك",
      "Submit": "إرسال",
      "Submitting...": "جارٍ الإرسال...",
      "Please fill all required fields.": "يرجى ملء جميع الحقول المطلوبة.",
      "Your question has been sent successfully!": "تم إرسال سؤالك بنجاح!",

  // BuildProjectPage

      // ProjectsPage
      "No images": "لا توجد صور",
      "images": "صور",
      "View Details": "عرض التفاصيل",
      "Our Projects": "مشاريعنا",
      "Loading projects...": "جارٍ تحميل المشاريع...",
      "Failed to load projects.": "فشل تحميل المشاريع.",
      "No projects available.": "لا توجد مشاريع متاحة.",
      "Close": "إغلاق",
      "Change language": "تغيير اللغة",
      "Previous image": "الصورة السابقة",
      "Next image": "الصورة التالية",
      "No images available.": "لا توجد صور متاحة.",
      "Download the app": "تحميل التطبيق",
      "App Store": " اب ستور",
      "Google Play": "جوجل بلاي",



    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ar",
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

document.documentElement.lang = "ar";
document.documentElement.dir = "rtl";

export default i18n;
